import { Box } from '@mui/material'

import {
  FlexRowBetweenBox,
  SubheaderText,
  Text,
} from '@/components/IncomeCard/TrustedSources/styles'
import { shouldShowEstimatedGrossIncome } from '@/components/IncomeCard/utils'
import type {
  IncomeType,
  OpenBankingOutcome as OpenBankingOutcomeValue,
} from '@/types/Activity'
import type { IncomeProperties } from '@/types/Income'

const StatBox: React.FC<{ label: string; value: string }> = ({ label, value }) => (
  <Box sx={{ flex: '0 0 auto', minWidth: '140px' }}>
    <SubheaderText variant="subtitle2">{label}</SubheaderText>
    <Text variant="body2">{value}</Text>
  </Box>
)

interface Props {
  outcome: OpenBankingOutcomeValue
  incomeProperties: IncomeProperties
  incomeType: IncomeType
  hasSingleIncome: boolean
}

const OpenBankingOutcome: React.FC<Props> = ({
  outcome,
  incomeProperties,
  incomeType,
  hasSingleIncome,
}) => {
  const estimatedGrossIncome = Number(outcome.estimatedGrossIncome)
  const estimatedNetIncome = Number(outcome.estimatedNetIncome)

  const hasEstimatedGrossIncome = shouldShowEstimatedGrossIncome(
    incomeType,
    hasSingleIncome,
    estimatedNetIncome,
    estimatedGrossIncome,
  )

  const hasBalance = typeof outcome.balance === 'number'

  return (
    <FlexRowBetweenBox sx={{ flexWrap: 'wrap', px: '4px' }}>
      {incomeType !== 'Savings' && (
        <StatBox
          label={`Estimated ${hasEstimatedGrossIncome ? 'Gross' : 'Net'} Monthly Income`}
          value={`${incomeProperties.currency?.symbol}${Number(
            hasEstimatedGrossIncome ? estimatedGrossIncome : estimatedNetIncome,
          ).toFixed(2)}`}
        />
      )}

      {incomeType !== 'Savings' && hasEstimatedGrossIncome && (
        <StatBox
          label="Estimated Net Monthly Income"
          value={`${incomeProperties.currency?.symbol}${estimatedNetIncome.toFixed(2)}`}
        />
      )}

      {hasBalance && (
        <StatBox
          label="Current balance"
          value={`${incomeProperties.currency?.symbol}${outcome.balance?.toFixed(2)}`}
        />
      )}
    </FlexRowBetweenBox>
  )
}

export default OpenBankingOutcome
